import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-project-list-skeleton',
    templateUrl: './project-list-skeleton.component.html',
    styleUrls: ['./project-list-skeleton.component.scss'],
  standalone: true
})
export class ProjectListSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
